import Box from '@mui/material/Box';
import GlobalStyles from '@mui/material/GlobalStyles';
import { useTheme } from '@mui/material/styles';

import { layoutClasses } from '../../utils/classes';
import { baseVars } from '../../utils/config-vars';

import type { Theme, SxProps, CSSObject } from '@mui/material/styles';

// ----------------------------------------------------------------------

export type LayoutSectionProps = {
  sx?: SxProps<Theme>;
  cssVars?: CSSObject;
  children?: React.ReactNode;
  footerSection?: React.ReactNode;
  headerSection?: React.ReactNode;
  sidebarSection?: React.ReactNode;
};

export function LayoutSection({
  sx,
  cssVars,
  children,
  footerSection,
  headerSection,
  sidebarSection,
}: LayoutSectionProps) {
  const theme = useTheme();

  const inputGlobalStyles = (
    <GlobalStyles
      styles={{
        body: {
          ...baseVars(theme),
          ...cssVars,
          margin: 0, // Ensure no margin
          padding: 0, // Ensure no padding
          width: '100vw', // Full width
          height: '100vh', // Full height
          overflow: 'hidden', // Prevent scrolling issues
        },
      }}
    />
  );

  return (
    <>
      {inputGlobalStyles}
      <Box
        id="root__layout"
        className={layoutClasses.root}
        sx={{
          display: 'flex',
          width: '100vw',
          height: '100vh',
          overflow: 'hidden',
          ...sx,
        }}
      >
        {sidebarSection}
        <Box
          display="flex"
          flex="1 1 auto"
          flexDirection="column"
          className={layoutClasses.hasSidebar}
          sx={{ width: '100%', height: '100%', overflow: 'hidden' }}
        >
          {headerSection}
          {children}
          {footerSection}
        </Box>
      </Box>
    </>
  );
}
